import { useQuery } from 'data-fetching-client';
import { userInfoSync } from 'hub-http/userInfo';
import { useCallback, useMemo } from 'react';
import { GET_USER_INFO } from '../queries/userInfo';
export const useUserInfo = () => {
  const cachedUserInfo = useMemo(() => {
    try {
      return userInfoSync();
    } catch (_unused) {
      return undefined;
    }
  }, []);
  const {
    data,
    error,
    loading
  } = useQuery(GET_USER_INFO, {
    skip: !!cachedUserInfo
  });
  const parsedData = useMemo(() => {
    return cachedUserInfo || (data === null || data === void 0 ? void 0 : data.userInfo);
  }, [cachedUserInfo, data === null || data === void 0 ? void 0 : data.userInfo]);
  const isUngatedFor = useCallback(gateKey => !!(parsedData !== null && parsedData !== void 0 && parsedData.gates.includes(gateKey)), [parsedData === null || parsedData === void 0 ? void 0 : parsedData.gates]);
  return useMemo(() => ({
    userInfo: parsedData,
    userInfoError: error,
    isLoadingUserInfo: loading,
    loading,
    isUngatedFor
  }), [error, isUngatedFor, loading, parsedData]);
};